import { apiClient } from './client';

/** Cohorts — named groups of a client organization's members, tracked and enrolled together. */

export async function getCohorts(orgId) {
  const { data } = await apiClient.get(`/organizations/${orgId}/cohorts`);
  return data;
}

export async function createCohort(orgId, body) {
  const { data } = await apiClient.post(`/organizations/${orgId}/cohorts`, body);
  return data;
}

export async function getCohort(id) {
  const { data } = await apiClient.get(`/cohorts/${id}`);
  return data;
}

export async function updateCohort(id, body) {
  const { data } = await apiClient.patch(`/cohorts/${id}`, body);
  return data;
}

export async function deleteCohort(id) {
  const { data } = await apiClient.delete(`/cohorts/${id}`);
  return data;
}

export async function addCohortMembers(id, body) {
  const { data } = await apiClient.post(`/cohorts/${id}/members`, body);
  return data;
}

export async function removeCohortMember(id, memberId) {
  const { data } = await apiClient.delete(`/cohorts/${id}/members/${memberId}`);
  return data;
}

export async function assignCohort(id, body) {
  const { data } = await apiClient.post(`/cohorts/${id}/assign`, body);
  return data;
}

export async function getCohortProgress(id) {
  const { data } = await apiClient.get(`/cohorts/${id}/progress`);
  return data;
}
